import { apolloClient } from "@/utils/graphql-client";
import { GET_Cashfloat } from "./queries/cashfloat.graphql";

/**
 * Returns cashfloat by uid.
 *
 * @param uid cashfloat uid
 */
export async function getCashfloatByUidFromBackend(uid: string) {
  const res = await apolloClient.query({
    query: GET_Cashfloat,
    variables: { condition: `(uid,eq,${uid})` },
  });

  const cashfloats = res.data.cashfloat;
  return cashfloats && cashfloats.length ? cashfloats[0] : null;
}
